export const MEDIA = {
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  LINKEDIN: 'LinkedIn',
  PINTEREST: 'Pinterest',
  X: 'X',
  YOUTUBE: 'Youtube',
};
